import { render, staticRenderFns } from "./DialogUpdateTask.vue?vue&type=template&id=10f8a286&scoped=true&"
import script from "./DialogUpdateTask.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateTask.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateTask.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DialogUpdateTask.vue?vue&type=style&index=1&id=10f8a286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8a286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f8a286')) {
      api.createRecord('10f8a286', component.options)
    } else {
      api.reload('10f8a286', component.options)
    }
    module.hot.accept("./DialogUpdateTask.vue?vue&type=template&id=10f8a286&scoped=true&", function () {
      api.rerender('10f8a286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogUpdateTask.vue"
export default component.exports